// src/modules/auth/services/verifyCode.ts

import { deleteCookie, setCookie } from "../../../utils/cookie.ts";
import { sendRequest } from "../../../utils/request.ts";
import { CODE_LENGTH, SINGLE_DIGIT_REGEX } from "../constants.ts";

interface Params {
  email: string;
  event: SubmitEvent;
}

export const verifyCode = async ({ event, email }: Params) => {
  event.preventDefault();

  const data = new FormData(event.target as HTMLFormElement);
  const code = [];
  for (let i = 1; i <= CODE_LENGTH; i++) {
    const digit = data.get(`code-${i}`);
    if (typeof digit === "string" && SINGLE_DIGIT_REGEX.test(digit)) {
      code.push(digit);
    }
  }

  await sendRequest({
    request: {
      url: "/api/auth/submit-code",
      method: "POST",
      body: { email, code: code.join("") },
    },
    submitButton: {
      button: event.submitter as HTMLButtonElement,
      text: "Zaloguj",
    },
    errorMessage: "Podany kod jest nieprawidłowy.",
    onSuccess: async (response) => {
      const { data } = await response.json();
      setCookie({ name: "user", value: JSON.stringify(data.user) });
      deleteCookie({ name: "email" });
      window.location.href = "/";
    },
  });
};
